import { render, staticRenderFns } from "./download3.vue?vue&type=template&id=8210d878&scoped=true"
import script from "./download3.vue?vue&type=script&lang=js"
export * from "./download3.vue?vue&type=script&lang=js"
import style0 from "./download3.vue?vue&type=style&index=0&id=8210d878&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8210d878",
  null
  
)

export default component.exports